(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4570],{

/***/ 14953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/media-coverage",
      function () {
        return __webpack_require__(9658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ArrowDown() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 5l5 5 5-5",
            stroke: "var(--color-blue)",
            strokeWidth: "2"
        })
    });
}


/***/ }),

/***/ 23775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61176);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var Typo = function(props) {
    var variant = props.variant, Tag = props.Tag, color = props.color, className = props.className, children = props.children, font = props.font;
    if (!Tag) {
        switch(variant){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
            case "blockquote":
                Tag = variant;
                break;
            default:
                Tag = "p";
        }
    }
    if (!variant) variant = "body";
    var classes = [
        (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().typo),
        variant ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(variant)] : null,
        color ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(color)] : null,
        font ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(font)] : null,
        className ? className : null, 
    ].filter(Boolean).join(" ");
    var modifiedProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: classes
    });
    // Remove props so they don't appear in DOM
    delete modifiedProps.variant;
    delete modifiedProps.Tag;
    delete modifiedProps.font;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, modifiedProps), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Typo);


/***/ }),

/***/ 22028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SidebarLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/auth.js
var store_auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./styles/modules/SidebarNav.module.scss
var SidebarNav_module = __webpack_require__(36360);
var SidebarNav_module_default = /*#__PURE__*/__webpack_require__.n(SidebarNav_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Nav/NavigationLinks.js + 10 modules
var NavigationLinks = __webpack_require__(41553);
;// CONCATENATED MODULE: ./components/SidebarNav.js






var SidebarNav = function() {
    var router = (0,next_router.useRouter)();
    var auth = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF);
    if (!router.query.company && !auth.company) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (SidebarNav_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationLinks/* default */.Z, {
            styles: (SidebarNav_module_default())
        })
    });
};
/* harmony default export */ var components_SidebarNav = (SidebarNav);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Svg/ArrowDown.js
var ArrowDown = __webpack_require__(87878);
// EXTERNAL MODULE: ./styles/modules/Breadcrumb.module.scss
var Breadcrumb_module = __webpack_require__(56992);
var Breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumb_module);
;// CONCATENATED MODULE: ./components/Nav/Breadcrumb.js






var Breadcrumb = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), links = ref[0], setLinks = ref[1];
    (0,react.useEffect)(function() {
        var paths = router.asPath.split("/").filter(Boolean);
        // paths.shift(); // used .filter(Boolean) instead
        var newPaths = [];
        paths.forEach(function(item, index) {
            newPaths.push("".concat(newPaths[index - 1] || "") + "/".concat(item));
        });
        setLinks(newPaths);
    }, []);
    // if (!router.query?.company) {
    //     return null;
    // }
    return (links === null || links === void 0 ? void 0 : links.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: [
            "mb-l",
            (Breadcrumb_module_default()).wrapper, 
        ].join(" "),
        children: links === null || links === void 0 ? void 0 : links.map(function(href, index) {
            var isLast = index === links.length - 1;
            var label;
            // index === 0
            //     ? 'Newspage'
            //     : href.split('/')[index + 1].replaceAll('-', ' ');
            if (index === 0) {
                if (router.asPath.includes("/news-story/")) {
                    label = "Newspage"; // TODO: Get company name instead
                } else {
                    label = "Newspage";
                }
            } else {
                label = href.split("/")[index + 1].replaceAll("-", " ");
            }
            var item;
            // if not last item, create a link
            if (!isLast) {
                item = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (Breadcrumb_module_default()).href,
                        children: label
                    })
                });
            } else {
                item = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Breadcrumb_module_default()).href,
                    children: label
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    item,
                    !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Nav_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./styles/modules/SidebarLayout.module.scss
var SidebarLayout_module = __webpack_require__(89722);
var SidebarLayout_module_default = /*#__PURE__*/__webpack_require__.n(SidebarLayout_module);
;// CONCATENATED MODULE: ./layouts/SidebarLayout.js




// breadcrumb={false}: the page renders its own trail.
function SidebarLayout(param) {
    var isAuthenticated = param.isAuthenticated, _breadcrumb = param.breadcrumb, breadcrumb = _breadcrumb === void 0 ? true : _breadcrumb, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (SidebarLayout_module_default()).layout,
            !isAuthenticated ? (SidebarLayout_module_default()).lightBackground : "", 
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: [
                "container",
                (SidebarLayout_module_default()).container
            ].join(" "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "row",
                    (SidebarLayout_module_default()).row
                ].join(" "),
                children: [
                    isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SidebarNav, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "page",
                            (SidebarLayout_module_default()).body
                        ].join(" "),
                        children: [
                            isAuthenticated && breadcrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Breadcrumb, {}),
                            children
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 9658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Coverages; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22028);
/* harmony import */ var components_Sidescreen__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6266);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64798);
/* harmony import */ var styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91908);
/* harmony import */ var styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44217);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25617);
/* harmony import */ var components_EmptyBlock__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80326);
/* harmony import */ var utils_seo_title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61055);
/* harmony import */ var store_ux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30807);
/* harmony import */ var store_company_coverage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57202);
/* harmony import */ var components_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8939);
/* harmony import */ var components_Profile_MissedCoverage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16111);
/* harmony import */ var store_company__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3383);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5056);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2962);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32505);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23775);
























var __N_SSG = true;
function Coverages(param) {
    var seo = param.seo;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(store_company__WEBPACK_IMPORTED_MODULE_14__/* .companySelector */ .yX), _data = ref.data, name = _data.name, companySlug = _data.slug, type = _data.type;
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_17__/* .authSelector */ .aF), isAuthorized = ref1.isAuthorized, isAdmin = ref1.isAdmin, isAuthenticated = ref1.isAuthenticated, company = ref1.company;
    var coverages = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(param) {
        var company = param.company;
        return company.coverages.data;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // The page is cached HTML built without a user, so who is looking is
    // resolved here instead of in getStaticProps.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isAuthenticated) {
            dispatch((0,store_auth__WEBPACK_IMPORTED_MODULE_17__/* .handleAuthorization */ .fy)(router.query.company));
        }
    }, [
        isAuthenticated,
        router.query.company
    ]);
    var handleAddCoverage = function() {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleShowSidescreen */ .Co)("add-mediaCoverage"));
    };
    var handleEditCoverage = function(id) {
        dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_11__/* .editCoverage */ .EC)(coverages.find(function(item) {
            return item.id === id;
        })));
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleShowSidescreen */ .Co)("edit-mediaCoverage"));
    };
    var newCoverageButton = isAdmin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        onClick: handleAddCoverage,
        classes: [
            (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().button)
        ],
        title: lang_en_json__WEBPACK_IMPORTED_MODULE_5__/* .profile.media_coverage.button */ .N5.iT.LI
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Profile_MissedCoverage__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().tellUs)
    });
    var handleRemovePopup = function(id) {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleShowPopup */ .YF)());
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupConfig */ .iH)({
            onConfirm: function() {
                return handleRemoveConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Delete Media coverage?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handleRemoveConfirm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupLoading */ .BI)(true));
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_11__/* .removeCoverage */ .zM)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupLoading */ .BI)(false));
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleHidePopup */ .Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveCancel = function() {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleHidePopup */ .Zi)());
    };
    var handlePin = function(id) {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleShowPopup */ .YF)());
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupConfig */ .iH)({
            onConfirm: function() {
                return handlePinConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Change pin status of the media coverage?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handlePinConfirm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupLoading */ .BI)(true));
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_11__/* .pinCoverage */ .$2)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .setPopupLoading */ .BI)(false));
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleHidePopup */ .Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePinConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var published = (coverages === null || coverages === void 0 ? void 0 : coverages.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().cardBlocks),
            children: coverages.map(function(item, key) {
                var ref;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    pretitle: item.publisher,
                    quotedOn: (ref = item.alert) === null || ref === void 0 ? void 0 : ref.title,
                    title: item.title,
                    publishedAt: item.createdAt,
                    link: item.url,
                    onRemove: isAuthorized && handleRemovePopup,
                    onEdit: isAdmin && handleEditCoverage,
                    editLabel: lang_en_json__WEBPACK_IMPORTED_MODULE_5__/* .profile.media_coverage.edit.button */ .N5.iT.eP.button,
                    cta: "Read more",
                    id: item.id,
                    titleLimit: 120,
                    status: item.status,
                    onApprove: companySlug === company && isAuthorized && handlePin
                }, "SingleCard-item-".concat(key));
            })
        })
    });
    var handleMarkCoveragesAsSeen = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_11__/* .seeCoverages */ .Fe)())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMarkCoveragesAsSeen() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isAuthenticated && company === companySlug && (coverages === null || coverages === void 0 ? void 0 : coverages.some(function(param) {
            var status = param.status;
            return status === "new";
        }))) {
            handleMarkCoveragesAsSeen();
        }
    }, [
        isAuthenticated,
        company,
        companySlug
    ]);
    var isEmpty = (coverages === null || coverages === void 0 ? void 0 : coverages.length) < 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_16__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, seo), {
                titleTemplate: (seo === null || seo === void 0 ? void 0 : seo.title) || (0,utils_seo_title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)("".concat(name, " Media Coverage")),
                noindex: isEmpty || type === "journalist",
                openGraph: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_15__/* ["default"].openGraph */ .Z.openGraph, seo === null || seo === void 0 ? void 0 : seo.openGraph)
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                isAuthenticated: isAuthenticated,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().wrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: [
                                    "mb-l",
                                    (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().titleWrapper)
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        variant: "h1",
                                        children: isAuthorized ? lang_en_json__WEBPACK_IMPORTED_MODULE_5__/* .profile.media_coverage.title */ .N5.iT.TN : "".concat(name, "'s Media Coverage")
                                    }),
                                    newCoverageButton
                                ]
                            }),
                            published,
                            isEmpty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyBlock__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                title: lang_en_json__WEBPACK_IMPORTED_MODULE_5__/* .profile.media_coverage.placeholder_empty */ .N5.iT.Xu
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Sidescreen__WEBPACK_IMPORTED_MODULE_4__["default"], {
                        closeFn: store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleHideSidescreen */ .Qb,
                        onUpdate: function() {
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_10__/* .handleHideSidescreen */ .Qb)());
                        }
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 95460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xv": function() { return /* binding */ escapeHtml; },
/* harmony export */   "ZP": function() { return /* binding */ safeHtml; },
/* harmony export */   "aY": function() { return /* binding */ isOwnHost; },
/* harmony export */   "oL": function() { return /* binding */ jsonLd; }
/* harmony export */ });
/* unused harmony export isExternalHref */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_2__);
// One allowlist for every piece of user HTML we render: alerts, responses,
// stories and profile bios. Most of it is CKEditor output (see ckeditor/src),
// so the tags below are what that build emits, and nothing else gets through.



// Newspage's own hosts, plus any subdomain of them (app., cdn., pay.).
// newspage.dev is the staging HOST from next.config.js.
var OWN_DOMAINS = [
    "newspage.media",
    "newspage.news",
    "newspage.dev"
];
var isOwnHost = function() {
    var hostname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var host = hostname.toLowerCase().replace(/\.$/, "");
    return OWN_DOMAINS.some(function(d) {
        return host === d || host.endsWith(".".concat(d));
    });
};
// Relative links and links to our own hosts are ours. `//host` is protocol
// relative and counts as external. mailto: is not a web page, so it is left
// alone rather than being opened in a new tab.
var isExternalHref = function() {
    var href = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var value = href.trim();
    if (/^mailto:/i.test(value)) return false;
    if (!/^(https?:)?\/\//i.test(value)) return false;
    try {
        return !isOwnHost(new URL(value, "https://app.newspage.media").hostname);
    } catch (e) {
        return true;
    }
};
// CKEditor's media embed (previewsInData) wraps the iframe in a div whose
// inline style holds the aspect ratio. Only these layout values are kept.
var LENGTH = [
    /^-?\d+(\.\d+)?(%|px)?$/
];
var OPTIONS = {
    allowedTags: [
        "p",
        "br",
        "strong",
        "b",
        "em",
        "i",
        "u",
        "s",
        "ins",
        "del",
        "sub",
        "sup",
        "span",
        "ul",
        "ol",
        "li",
        "h2",
        "h3",
        "h4",
        "a",
        "blockquote",
        "figure",
        "figcaption",
        "img",
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td",
        "div",
        "iframe", 
    ],
    allowedAttributes: {
        a: [
            "href",
            "target",
            "rel"
        ],
        img: [
            "src",
            "alt",
            "width",
            "height"
        ],
        th: [
            "colspan",
            "rowspan"
        ],
        td: [
            "colspan",
            "rowspan"
        ],
        div: [
            "data-oembed-url",
            "style"
        ],
        iframe: [
            "src",
            "width",
            "height",
            "style",
            "allow",
            "allowfullscreen",
            "frameborder", 
        ],
        "*": [
            "class"
        ]
    },
    // Image style and table/media wrappers from the editor; no free-form classes.
    allowedClasses: {
        "*": [
            "image",
            "image-inline",
            "image-style-*",
            "table",
            "media"
        ]
    },
    allowedStyles: {
        div: {
            position: [
                /^relative$/
            ],
            height: LENGTH,
            "padding-bottom": LENGTH
        },
        iframe: {
            position: [
                /^absolute$/
            ],
            width: LENGTH,
            height: LENGTH,
            top: LENGTH,
            left: LENGTH
        }
    },
    allowedSchemes: [
        "http",
        "https",
        "mailto"
    ],
    allowedSchemesByTag: {
        img: [
            "http",
            "https"
        ],
        iframe: [
            "https"
        ]
    },
    // The providers CKEditor renders a preview iframe for.
    allowedIframeHostnames: [
        "www.youtube.com",
        "www.youtube-nocookie.com",
        "player.vimeo.com",
        "www.dailymotion.com",
        "open.spotify.com", 
    ],
    allowIframeRelativeUrls: false,
    transformTags: {
        a: function(tagName, attribs) {
            if (!isExternalHref(attribs.href)) {
                return {
                    tagName: tagName,
                    attribs: attribs
                };
            }
            return {
                tagName: tagName,
                attribs: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, attribs), {
                    rel: "nofollow noopener",
                    target: "_blank"
                })
            };
        }
    }
};
function safeHtml(html) {
    if (!html) return "";
    return sanitize_html__WEBPACK_IMPORTED_MODULE_2___default()(String(html), OPTIONS);
}
// Plain text going into an HTML string, e.g. a title wrapped in <h1>.
var escapeHtml = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return String(text !== null && text !== void 0 ? text : "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
};
// JSON-LD body for <script type="application/ld+json">. A "</script>" inside
// any string value would otherwise close the tag and run what follows.
var jsonLd = function(obj) {
    return JSON.stringify(obj).replace(/</g, "\\u003c");
};


/***/ }),

/***/ 61055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GH": function() { return /* binding */ ellipsise; },
/* harmony export */   "WL": function() { return /* binding */ TITLE_MAX; },
/* harmony export */   "ZP": function() { return /* binding */ pageTitle; },
/* harmony export */   "mL": function() { return /* binding */ articleTitle; },
/* harmony export */   "pW": function() { return /* binding */ SITE_SUFFIX; },
/* harmony export */   "px": function() { return /* binding */ SITE_NAME; }
/* harmony export */ });
/* unused harmony export ARTICLE_TITLE_MAX */
/* harmony import */ var _text_truncate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59965);

var TITLE_MAX = 60;
var SITE_NAME = "Newspage";
var SITE_SUFFIX = "| ".concat(SITE_NAME);
var ellipsise = function(text, max) {
    return "".concat((0,_text_truncate_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(text, max - 2, true).slice(0, -3).replace(/[\s,;:.!?–—-]+$/, ""), "…");
};
var BASE_MAX = TITLE_MAX - SITE_SUFFIX.length - 1;
function pageTitle(base) {
    var text = typeof base === "string" ? base.trim() : "";
    if (!text) {
        return SITE_NAME;
    }
    var full = "".concat(text, " ").concat(SITE_SUFFIX);
    return full.length <= TITLE_MAX ? full : "".concat(ellipsise(text, BASE_MAX), " ").concat(SITE_SUFFIX);
}
// News and alert headlines are the page's reason to rank, so they get more
// room than pageTitle's 60, and the headline wins over the site suffix: the
// suffix goes first, then words from the end.
var ARTICLE_TITLE_MAX = 70;
function articleTitle(base) {
    var text = typeof base === "string" ? base.trim() : "";
    if (!text) {
        return SITE_NAME;
    }
    var full = "".concat(text, " ").concat(SITE_SUFFIX);
    if (full.length <= ARTICLE_TITLE_MAX) {
        return full;
    }
    return text.length <= ARTICLE_TITLE_MAX ? text : ellipsise(text, ARTICLE_TITLE_MAX);
}


/***/ }),

/***/ 92131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ tagRemove; }
/* harmony export */ });
// Block ends and line breaks become a space, so paragraphs don't run together
// ('stop".Nationwide') once the tags are gone.
var BREAK = /<\/(p|li|h[1-6]|div|blockquote)\s*>|<br\s*\/?>/gi;
function tagRemove() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (data === null) {
        return "";
    }
    return data.replace(BREAK, " ").replace(/(<([^>]+)>)/gi, "").replace(/\s+/g, " ").trim();
}


/***/ }),

/***/ 59965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ truncate; }
/* harmony export */ });
function truncate(str, n, useWordBoundary) {
    if (str.length <= n) {
        return str;
    }
    var subString = str.substr(0, n - 1); // the original check
    var boundary = subString.lastIndexOf(" ");
    return (useWordBoundary && boundary > 0 ? subString.slice(0, boundary) : subString) + "...";
}


/***/ }),

/***/ 56992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__0Agi8","href":"Breadcrumb_href__Toawd"};

/***/ }),

/***/ 89722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"SidebarLayout_layout__3iedG","container":"SidebarLayout_container__ojXS5","row":"SidebarLayout_row__LDQOd","body":"SidebarLayout_body__x7PlU","lightBackground":"SidebarLayout_lightBackground__kJ0gF"};

/***/ }),

/***/ 36360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SidebarNav_wrapper__iWGk3","list":"SidebarNav_list__7bZP3","tooltip":"SidebarNav_tooltip__Soj6L","item":"SidebarNav_item__hRhK_","title":"SidebarNav_title__ZdCkY","active":"SidebarNav_active__J_l9i","notification":"SidebarNav_notification__sNqIG"};

/***/ }),

/***/ 61176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typo--serif":"Typo_typo--serif__ahG_k","typo--h1":"Typo_typo--h1__k9d1d","typo--h2":"Typo_typo--h2__ERFQP","typo--h3":"Typo_typo--h3__96TzI","typo--h4":"Typo_typo--h4__50rIx","typo--eyebrow":"Typo_typo--eyebrow__ZpogH","typo--perex":"Typo_typo--perex__jtAL0","typo--body":"Typo_typo--body__N8tZg","typo--small":"Typo_typo--small__IMpLY","typo--caption":"Typo_typo--caption__BQ_Ci","typo--special":"Typo_typo--special__PCh7S","typo--quote":"Typo_typo--quote__kbLSb","typo--quote-author":"Typo_typo--quote-author__gGzSj"};

/***/ }),

/***/ 91908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper__NuUSz","titleWrapper":"Index_titleWrapper__UymEn","button":"Index_button__RsieF","tellUs":"Index_tellUs__WKtGK","cardBlocks":"Index_cardBlocks__KwCMm"};

/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1036,2283,9747,1345,362,7883,355,5050,9774,2888,179], function() { return __webpack_exec__(14953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);